import { InjectionToken, Provider } from '@angular/core';

export type ApplicationScope = 'mainUI' | 'system';

export type TokenNames = 'nb_kc_token';

export type ClientIds = 'nb_kc_client';

export interface ICoreConfig {
  API_BASE: string;
  WEB_STORAGE_NAMES: {
    TOKEN: TokenNames;
  };
  CLIENT_ID: ClientIds;
}

export const CORE_CONFIG_TOKEN = new InjectionToken<ICoreConfig>('core.module.config');

export const config: ICoreConfig = {
  API_BASE: '/api',
  WEB_STORAGE_NAMES: {
    TOKEN: 'nb_kc_token',
  },
  CLIENT_ID: 'nb_kc_client',
};

export const coreConfigProvider: Provider = {
  provide: CORE_CONFIG_TOKEN,
  useValue: config,
};
